import { Link } from 'react-router-dom';
import { links, translations } from '../../../utils/staticContent';
import Affiliates from '../Affiliates';
import Donation from '../Donation';
import SocialIcons from '../SocialIcons';
import './style.scss';

function Footer() {
    return (
        <footer className="Footer">
            <div className="footer-wrapper container-wide">
                <div className="footer-item footer-first">
                    <img src="/footer_red.svg" className="footer-bg" />
                    <div className="footer-first-content">
                        <SocialIcons />
                        <Donation />
                    </div>
                </div>
                <div className="footer-item footer-second">
                    <img src="/footer_black.svg" className="footer-bg" />
                    <div className="footer-second-content">
                        <Affiliates />
                        <SocialIcons />
                    </div>
                </div>
                <div className="footer-item footer-third">
                    <img src="/krem.svg" className="footer-bg" />
                    <Link to={links.about}>
                        <div className="footer-third-content">{translations.aboutUs}</div>
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
